import Materials from "../views/Material/Materials";
import IncomingMaterialsListView from "../views/Material/IncomingMaterialsListView";
import Material from "../views/Material/Material";
import MaterialSummary from "../views/Material/MaterialSummary";
import MaterialRawMaterials from "../views/Material/MaterialRawMaterials";
import MaterialLabelPrint from "../views/Material/MaterialLabelPrint";
import MaterialQuality from "../views/Material/MaterialQuality";
import MaterialBatches from "../views/Material/MaterialBatches";
import MaterialAttachments from "../views/Material/MaterialAttachments";

export default [
  {
    path: "/Materials",
    name: "Materials",
    component: Materials,
  },
  {
    path: "/IncomingMaterials",
    name: "IncomingMaterialsListView",
    component: IncomingMaterialsListView,
  },
  {
    path: "/Materials/:id",
    component: Material,
    props: true,
    children: [
      {
        path: "Summary",
        name: "MaterialDetail",
        component: MaterialSummary,
        props: true,
      },
      {
        path: "RawMaterials",
        name: "RawMaterials",
        component: MaterialRawMaterials,
        props: true,
        children: [
          {
            path: ":rawid",
            name: "RawMaterialPrint",
            component: MaterialLabelPrint,
            props: true,
          }
        ]
      },
      {
        path: "Quality",
        name: "MaterialQuality",
        component: MaterialQuality,
        props: true,
      },
      {
        path: "Batches",
        name: "MaterialBatches",
        component: MaterialBatches,
        props: true,
      },
      {
        path: "Attachments",
        name: "MaterialAttachments",
        component: MaterialAttachments,
        props: true,
      }
    ]
  },
]